const func = ($target) => {
	$(document).ready(function(){
		$('.related-product-section').toggleClass('show');
		var $relatedProductSlider = $target.find(".related-products");
		window.loader.key("swiper", function () {
			var swiper = new Swiper($relatedProductSlider, {
				slidesPerView: 3,
				spaceBetween: 30,
				// autoplay:true,
				loop:false,
				simulateTouch: false,
				navigation: {
					nextEl: $target.find(".swiper-button-next"),
					prevEl: $target.find(".swiper-button-prev"),
				},
				breakpoints: {
					1199:{
						slidesPerView:3,
						spaceBetween:0,
					},
					991:{
						slidesPerView:2,
						spaceBetween:0,
					},
					768:{
						slidesPerView:2,
						spaceBetween:0,
					},
					575: {
						slidesPerView:1,
						spaceBetween:0,
					}
				}
			});
		});
	});
};

export default func;
